export default __webpack_public_path__ + "static/media/menuBackgroundSwirl.eee19175.svg";